import { back } from '@lagunovsky/redux-react-router'
import HomeAction from 'home/actions/HomeAction'
import BoundaryError from 'log/components/BoundaryError'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Outlet } from 'react-router-dom'
import i18n from 'simple-react-i18n'
import AppStore from 'store/AppStore'
import ToastrAction from 'toastr/actions/ToastrAction'
import { H_SITUATION_MODULE } from '../../account/constants/AccessRulesConstants'
import User from '../../account/dto/User'
import { H_SITUATION_MODEL_OPTIONS, H_SITUATION_OPTIONS } from 'account/constants/AccessRulesConstants'
import FixedSlideNav from '../../components/navbar/FixedSlideNav'
import { PATH_ALERT, PATH_ALERT_CONFIGURATION, PATH_MODEL_CONFIGURATION } from '../../home/constants/RouteConstants'
import { componentHasHabilitations } from '../../utils/HabilitationUtil'
import { Box } from '@mui/material'
import { ALIGN } from 'components/datatable/NewTable'


class AlertApp extends Component {
    componentDidMount() {
        this.checkAbillitation()
        AppStore.dispatch(HomeAction.setHelpLink('gemapi'))
    }

    componentDidUpdate() {
        this.checkAbillitation()
    }

    checkAbillitation = () => {
        const { user, toastError } = this.props
        if (user && user.login) {
            const isAuthorized = componentHasHabilitations(H_SITUATION_MODULE)
            if (!isAuthorized) {
                this.props.back()
                toastError(i18n.AccessRightDeny)
            }
        }
    }

    getLinks = () => {
        const modelOptions = componentHasHabilitations(H_SITUATION_MODEL_OPTIONS) ? [{
            href: PATH_MODEL_CONFIGURATION,
            icons: 'auto_awesome_mosaic',
            name: i18n.modelOptions,
        }] : []

        const alertOptions = componentHasHabilitations(H_SITUATION_OPTIONS) ? [{
            href: PATH_ALERT_CONFIGURATION,
            icons: 'settings',
            name: i18n.alertOptions,
            position: ALIGN.BOTTOM,
        }] : []
        const links = [
            {
                href: PATH_ALERT,
                icons: 'map',
                name: i18n.map,
            },
            ...modelOptions,
            ...alertOptions,
        ]
        return links
    }

    render() {
        return (
            <div className='row no-margin'>
                <FixedSlideNav links={ this.getLinks() }/>
                <div className='content-page no-padding fullscreen'>
                    <BoundaryError>
                        <Box sx={{ padding: '10px' }}>
                            <Outlet />
                        </Box>
                    </BoundaryError>
                </div>
            </div>
        )
    }
}

AlertApp.propTypes = {
    children: PropTypes.element,
    getLink: PropTypes.func,
    user: PropTypes.instanceOf(User),
    back: PropTypes.func,
    toastError: PropTypes.func,
}

const mapStateToProps = store => ({
    user: store.AccountReducer.accountUser,
})

const mapDispatchToProps = {
    back,
    toastError: ToastrAction.error,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AlertApp)
